import LoginAsUser from "./LoginAsUser"
import UserTable from "./UserTable"

const Users = () => {
  return (
    <div>
        <LoginAsUser />
        <UserTable />
    </div>
  )
}

export default Users